/* eslint-disable @typescript-eslint/no-require-imports */
export const logger = require('pino')();